import { useId } from 'react'
import { Link } from 'react-router'
import styles from './MostRead.module.css'

export interface MostReadStory {
  id: string
  to: string
  title: string
}

export interface MostReadProps {
  stories: MostReadStory[]
  title?: string
  className?: string
}

/** A numbered "Most read" list for a news rail. Renders nothing when empty. */
export function MostRead({ stories, title = 'Most read this week', className }: MostReadProps) {
  const id = useId()
  if (stories.length === 0) return null
  return (
    <section className={[styles.card, className].filter(Boolean).join(' ')} aria-labelledby={id}>
      <h2 id={id} className={styles.title}>{title}</h2>
      <ol className={styles.list}>
        {stories.map((s, i) => (
          <li key={s.id}>
            <Link to={s.to} className={styles.item}>
              <span className={styles.rank} aria-hidden="true">{i + 1}</span>
              <span className={styles.headline}>{s.title}</span>
            </Link>
          </li>
        ))}
      </ol>
    </section>
  )
}
